import { cn, Loading, Tooltip } from "@kyan/ui";
import React from "react";

import { RequestStatusEnum } from "#/services/bridge/bridge.types";

import { BRIDGE_STATUS_CONFIG } from "./BridgeStatus.constants";

interface BridgeStatusProps {
  status: RequestStatusEnum;
}

export const BridgeStatus: React.FC<BridgeStatusProps> = ({ status }) => {
  const isLoading = status < RequestStatusEnum.FULFILLED;
  const { label, color, description } = BRIDGE_STATUS_CONFIG[status];

  return (
    <Tooltip
      content={
        <div className="max-w-xs text-center leading-snug">{description}</div>
      }
    >
      <span
        className={cn(
          "flex items-center gap-1 rounded-full py-1 text-xs",
          color,
        )}
      >
        {label}
        {isLoading && <Loading />}
      </span>
    </Tooltip>
  );
};
